import React, { useEffect, useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Menu, X, ChevronRight, Mail, Phone, MapPin } from 'lucide-react';
import { Button } from './ui/Button';
import { Logo } from './ui/Logo';
import { WhatsAppChat } from './WhatsAppChat';
import { CFA_INFO, SITE_LAST_UPDATED, QUALIOPI_LOGO } from '../data/constants';
const NAV_LINKS = [{
  name: 'Accueil',
  path: '/'
}, {
  name: 'Notre CFA',
  path: '/le-cfa'
}, {
  name: 'Vie étudiante',
  path: '/bde'
}, {
  name: 'CAP 360',
  path: '/candidater#cap-360-section' // Redirige vers la section CAP 360
}, {
  name: 'Formations',
  path: '/formations'
}, {
  name: 'Admissions',
  path: '/candidater'
}, {
  name: 'Entreprises',
  path: '/entreprises'
}, {
  name: 'Qualité & engagements',
  path: '/qualite'
}];
export function Layout() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);
  return <div className="min-h-screen flex flex-col bg-background font-sans" data-id="element-370" data-mp="1rmjx7lcrffle">
      {/* Header */}
      <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60" data-id="element-371" data-mp="1wlo6sd3ljfc9">
        <div className="container flex h-20 items-center justify-between" data-id="element-372" data-mp="13ucw68w3akfn">
          <Logo data-id="element-373" data-mp="13wplx8839z39" />

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-6" data-id="element-374" data-mp="18sy1unu41wbh">
            {NAV_LINKS.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors hover:text-primary ${location.pathname === link.path || link.path !== '/' && location.pathname.startsWith(link.path) ? 'text-primary' : 'text-muted-foreground'}`} data-id="element-375" data-mp="1dtvdehkm7s40">
                {link.name}
              </Link>)}
          </nav>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center gap-3" data-id="element-376" data-mp="1und7m74zk5nh">
            <Button variant="outline" asChild data-id="element-377" data-mp="29hrfpcn0hund">
              <Link to="/entreprises" data-id="element-378" data-mp="24jg4oykzde3k">Recruter un alternant</Link>
            </Button>
            <Button asChild data-id="element-379" data-mp="24hc0efj66d2r">
              <Link to="/candidater" data-id="element-380" data-mp="1gt2j9qwwidhy">Candidater</Link>
            </Button>
          </div>

          {/* Mobile Menu Toggle */}
          <Button variant="ghost" size="icon" aria-label="Menu" className="lg:hidden" onClick={() => setIsMobileMenuOpen(true)} data-id="element-381" data-mp="1bvtzxn00o3f4">
            <Menu className="h-6 w-6" data-id="element-382" data-mp="1lrx5z3xzom7c" />
          </Button>
        </div>
      </header>

      {/* Custom Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="fixed inset-0 w-[100vw] min-h-[100dvh] overflow-y-auto isolate lg:hidden" style={{
      backgroundColor: '#FFFFFF',
      opacity: 1,
      zIndex: 99999
    }} data-id="element-383" data-mp="t49q227nyjr1">
          <div className="flex flex-col min-h-full p-6" data-id="element-384" data-mp="39jo4q5rqwg64">
            {/* Header du menu */}
            <div className="flex items-center justify-between mb-8" data-id="element-385" data-mp="2uui6ak0qetza">
              <Logo showTagline={false} data-id="element-386" data-mp="2zrqt4xwtrm6v" />
              <Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(false)} aria-label="Fermer le menu" data-id="element-387" data-mp="2zstkt81z1snu">
                <X className="h-8 w-8 text-primary-dark" data-id="element-388" data-mp="3sg64nagqzmdg" />
              </Button>
            </div>

            {/* Liens du menu */}
            <nav className="flex flex-col gap-6 flex-1" data-id="element-389" data-mp="3iiro7autqxl5">
              {NAV_LINKS.map(link => <Link key={link.name} to={link.path} onClick={() => setIsMobileMenuOpen(false)} className={`text-2xl font-bold font-heading transition-colors hover:text-brand-orange ${location.pathname === link.path || link.path !== '/' && location.pathname.startsWith(link.path) ? 'text-primary' : 'text-primary-dark'}`} data-id="element-390" data-mp="2321365ze3sjy">
                  {link.name}
                </Link>)}
            </nav>

            {/* Boutons d'action */}
            <div className="flex flex-col gap-4 mt-12 pb-8" data-id="element-391" data-mp="28mw91p009yx5">
              <Button size="lg" variant="outline" className="w-full justify-center border-primary/20 text-primary-dark hover:bg-primary/5 text-lg py-6" asChild onClick={() => setIsMobileMenuOpen(false)} data-id="element-392" data-mp="369d4spt3c4gs">
                <Link to="/entreprises" data-id="element-393" data-mp="2sa40ooi5t0t6">Recruter un alternant</Link>
              </Button>
              <Button size="lg" className="w-full justify-center bg-brand-orange hover:bg-[#E67E22] text-white text-lg py-6 shadow-xl" asChild onClick={() => setIsMobileMenuOpen(false)} data-id="element-394" data-mp="1kwacouzd632z">
                <Link to="/candidater" data-id="element-395" data-mp="3sjvblebqqstj">Candidater</Link>
              </Button>
            </div>
          </div>
        </div>}

      {/* Main Content */}
      <main className="flex-1" data-id="element-396" data-mp="5ct16e6h59tj">
        <Outlet data-id="element-397" data-mp="5brn00u5w77l" />
      </main>

      {/* Footer */}
      <footer className="bg-primary-dark text-lavande pt-20 pb-10 border-t-4 border-primary" data-id="element-398" data-mp="a3ri9fzaebxu">
        <div className="container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-399" data-mp="f3e4ug1094jb">
          {/* Identity */}
          <div className="space-y-6" data-id="element-400" data-mp="k1fnizuir1u9">
            <Logo light className="mb-2" data-id="element-401" data-mp="k0e2c2jsgyyt" />
            <div className="space-y-2 text-sm text-lavande/80" data-id="element-402" data-mp="o3ao224mlb6z">
              <p className="font-bold text-white" data-id="element-403" data-mp="o1pqs4qxfe5f">{CFA_INFO.legalName}</p>
              <p data-id="element-404" data-mp="t2diksmzbz0p">SIRET : {CFA_INFO.siret}</p>
              <p data-id="element-405" data-mp="2pv70rf2j4r3c">UAI : {CFA_INFO.uai}</p>
              <p data-id="element-406" data-mp="2pwgzm6h7i3b1">NDA : {CFA_INFO.nda}</p>
              <p data-id="element-407" data-mp="2pxjok8uyxvob">Président : {CFA_INFO.president}</p>
            </div>

            {/* Qualiopi certificate */}
            <div className="flex pt-2" data-id="element-408" data-mp="1zs2y0t9pgk4">
              <span className="inline-flex items-center justify-center bg-white rounded-xl p-4 shadow-sm" data-id="element-409" data-mp="20tcg0umxuzq">
                <img src={QUALIOPI_LOGO} alt="Certification Qualiopi — processus certifié, République Française" className="w-44 h-auto object-contain" data-id="element-410" data-mp="3t7e9q2ba9z57" />
              </span>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-6" data-id="element-411" data-mp="kx309fvc9zwx">
            <h3 className="font-heading font-bold text-lg text-white" data-id="element-412" data-mp="fzkolhpxt6l8">
              Contact
            </h3>
            <ul className="space-y-4 text-sm" data-id="element-413" data-mp="tqptay85wp2f">
              <li className="flex items-start gap-3" data-id="element-414" data-mp="tqg1d53k47u3">
                <div className="w-8 h-8 rounded-full bg-primary/40 flex items-center justify-center shrink-0" data-id="element-415" data-mp="ppmfsidl754d">
                  <MapPin className="w-4 h-4 text-white" data-id="element-416" data-mp="13olyl9ef4psm" />
                </div>
                <span className="pt-1.5" data-id="element-417" data-mp="yqas98nc0xf5">{CFA_INFO.address}</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-418" data-mp="yo7t9z47btya">
                <div className="w-8 h-8 rounded-full bg-primary/40 flex items-center justify-center shrink-0" data-id="element-419" data-mp="1id5mx0n2bf8d">
                  <Phone className="w-4 h-4 text-white" data-id="element-420" data-mp="1naf8u6b8t8rg" />
                </div>
                <span className="font-medium text-white" data-id="element-421" data-mp="18cmvnkt64wgf">{CFA_INFO.phone}</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-422" data-mp="1dbq1v8kvx8pz">
                <div className="w-8 h-8 rounded-full bg-primary/40 flex items-center justify-center shrink-0" data-id="element-423" data-mp="zlct54065pzl">
                  <Mail className="w-4 h-4 text-white" data-id="element-424" data-mp="14bt7cqbtdfn0" />
                </div>
                <a href={`mailto:${CFA_INFO.email}`} className="hover:text-white transition-colors font-medium" data-id="element-425" data-mp="14dw7422rqn4x">
                  {CFA_INFO.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Navigation */}
          <div className="space-y-6" data-id="element-426" data-mp="gouu01izqntb">
            <h3 className="font-heading font-bold text-lg text-white" data-id="element-427" data-mp="koc0mya5lr02">
              Navigation
            </h3>
            <ul className="space-y-3 text-sm font-medium" data-id="element-428" data-mp="112jqo24bwwqh">
              <li data-id="element-429" data-mp="w4i8rkin33gl">
                <Link to="/" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-430" data-mp="w48jy09bz2ch">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-431" data-mp="r7i49e1fu8rl" /> Accueil
                </Link>
              </li>
              <li data-id="element-432" data-mp="i4qqh7l3b0ws">
                <Link to="/le-cfa" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-433" data-mp="i58s6jqiu7c3">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-434" data-mp="dc5z0cpnozwf" /> Le CFA
                </Link>
              </li>
              <li data-id="element-435" data-mp="3g2yfbagd9bl">
                <Link to="/bde" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-436" data-mp="3gm4nuqqq99s">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-437" data-mp="3unynsfb6owsc" /> Le BDE
                </Link>
              </li>
              <li data-id="element-438" data-mp="262rtti6e4ex9">
                <Link to="/formations" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-439" data-mp="2639m63pxm8zw">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-440" data-mp="2a5xy4k9xzw13" /> Nos
                  formations
                </Link>
              </li>
              <li data-id="element-441" data-mp="2k17y72gs5tc8">
                <Link to="/candidater" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-442" data-mp="2k1r7jusd79en">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-443" data-mp="1rcu06mpoyx0o" />{' '}
                  Candidater
                </Link>
              </li>
              <li data-id="element-444" data-mp="1wbdo2snuiivo">
                <Link to="/entreprises" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-445" data-mp="1wavllealb8fb">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-446" data-mp="13nhsjra0ix0h" /> Espace
                  Entreprises
                </Link>
              </li>
              <li data-id="element-447" data-mp="itvzj310o8zi">
                <Link to="/contact" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-448" data-mp="iuf7bqwydgzt">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-449" data-mp="nujntgxv2bq1" /> Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Informations utiles */}
          <div className="space-y-6" data-id="element-450" data-mp="xok3gcqrqzd0">
            <h3 className="font-heading font-bold text-lg text-white" data-id="element-451" data-mp="3xi3wbbx3j7">
              Informations utiles
            </h3>
            <ul className="space-y-3 text-sm font-medium" data-id="element-452" data-mp="530obk31pfsr">
              <li data-id="element-453" data-mp="a1lojjiarzh7">
                <Link to="/qualite" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-454" data-mp="a1251yd01312">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-455" data-mp="etv8miwqe5bk" /> Qualité
                  & Qualiopi
                </Link>
              </li>
              <li data-id="element-456" data-mp="3ig3u9ekrn2xn">
                <Link to="/accessibilite" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-457" data-mp="3ifkh0b6292py">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-458" data-mp="1vk5u36vc0ik9" />{' '}
                  Accessibilité Handicap
                </Link>
              </li>
              <li data-id="element-459" data-mp="1qn5rx71lrzyf">
                <Link to="/reclamations" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-460" data-mp="1lmhykepwj711">
                  <ChevronRight className="w-3 h-3 text-brand-orange" data-id="element-461" data-mp="1gp9icjobdd2f" />{' '}
                  Réclamations
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="container pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-lavande/60" data-id="element-462" data-mp="17sqqlartjv7f">
          <div className="flex flex-col items-center md:items-start gap-1" data-id="element-463" data-mp="xwx4p0s7mpcz">
            <p className="font-medium" data-id="element-464" data-mp="sxuakbdrq3js">
              © {new Date().getFullYear()} {CFA_INFO.name}. Tous droits
              réservés.
            </p>
            <p className="text-lavande/50" data-id="element-465" data-mp="j8dmlra5sw5o">
              Site mis à jour le {SITE_LAST_UPDATED}
            </p>
          </div>
          <div className="flex items-center gap-6 font-medium" data-id="element-466" data-mp="o6ow20wjl4nd">
            <Link to="/mentions-legales" className="hover:text-white transition-colors" data-id="element-467" data-mp="aaldj4v16kqq">
              Mentions légales
            </Link>
            <Link to="/confidentialite" className="hover:text-white transition-colors" data-id="element-468" data-mp="121hhth30zh2e">
              Politique de confidentialité
            </Link>
            <Link to="/cgv" className="hover:text-white transition-colors" data-id="element-469" data-mp="t8xs564pomtp">
              CGV
            </Link>
          </div>
        </div>
      </footer>

      <WhatsAppChat data-id="element-470" data-mp="x7n3yua3pwb8" />
    </div>;
}